var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.guideWrap,on:{"click":_vm.handleUpload}},[_c('img',{staticClass:"img",attrs:{"src":_vm.imgUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }